import { HTMLAttributes } from 'react';
import { CTAButtonTypes } from '../../../../components/ctaButton/CTAButtonTypes';
export namespace CTASectionTypes {
  export interface ICTASection extends HTMLAttributes<HTMLDivElement> {
    description: string;
    title?: string;
    theme?: TColorTheme;
    callToAction: CTAButtonTypes.TCallToAction;
    variant: TCTAVariants;
  }

  export type TColorTheme = 'light' | 'dark';

  export type TColorType = 'primary' | 'secondary' | 'accent' | string;
  export type TCTAVariants =
    | 'CTASectionWithTitleDescription'
    | 'CTASectionWithDescriptionOnly'
    | 'CTASectionWithTitleOnly';
  export type KnobVariantOptionsType = {
    WithTitleDescription: TCTAVariants;
    WithDescriptionOnly: TCTAVariants;
    WithTitleOnly: TCTAVariants;
  };
}
